import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Prism from 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/components/prism-json';
import { apiDocStyles } from '../styles/apiDocStyles';

const CodeBlock = ({ code, language = 'json', title }) => {
  const { t } = useTranslation();
  const codeRef = useRef(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (codeRef.current) {
      Prism.highlightElement(codeRef.current);
    }
  }, [code, language]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div style={apiDocStyles.codeBlock}>
      <div style={apiDocStyles.codeBlockHeader}>
        <span style={apiDocStyles.codeBlockTitle}>{title}</span>
        <button
          style={{
            ...apiDocStyles.copyButton,
            borderColor: copied ? '#10b981' : '#4b5563',
            color: copied ? '#10b981' : '#9ca3af',
          }}
          onClick={handleCopy}
        >
          {copied ? t('apiDoc.copied') : t('apiDoc.copy')}
        </button>
      </div>
      <pre style={{ margin: 0, overflow: 'auto' }}>
        <code
          ref={codeRef}
          className={`language-${language}`}
          style={apiDocStyles.codeContent}
        >
          {code}
        </code>
      </pre>
    </div>
  );
};

export default CodeBlock;
